module.exports = __webpack_public_path__ + "static/tags-9df5be38edc520a33c74ac8a17517243.png";